export const getDefaultTagColor = (color?: string | undefined) =>
  color || '#474d66';
